import { useState, useEffect } from 'react';
import isMobileHelper from '../utils/isMobile';

// Simple hook that returns true when the viewport width is <= the given breakpoint.
export default function useIsMobile(breakpoint = 768) {
  const isClient = typeof window !== 'undefined';
  const [isMobile, setIsMobile] = useState(() => (isClient ? isMobileHelper(breakpoint) : false));

  useEffect(() => {
    if (!isClient) return;
    const onResize = () => setIsMobile(isMobileHelper(breakpoint));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint, isClient]);

  return isMobile;
}
